<script lang="ts" setup>
import type { BlogCollectionItem } from '@nuxt/content';

const props = defineProps<{
  article: Pick<BlogCollectionItem, 'path' | 'image' | 'title'>;
}>();

const link = computed(() => articleLink(props.article.path));
</script>

<template>
  <NuxtLink :to="link" class="productBlogCard">
    <NuxtImg
      :src="article.image.src"
      :sizes="IMAGE_SIZES.blogInCatalog"
      :alt="article.image.alt"
      format="webp"
      class="productBlogCard__image"
    />

    <p class="productBlogCard__text">
      {{ article.title }}
    </p>
  </NuxtLink>
</template>

<style lang="scss">
.productBlogCard {
  position: relative;
  height: fit-content;

  &__image {
    aspect-ratio: 338 / 444;
    object-fit: cover;
    display: block;
    width: 100%;
    overflow-wrap: anywhere;
  }

  &__text {
    font-size: 24px;
    line-height: 120%;
    text-align: center;
    color: #ffffff;
    position: absolute;
    padding: 32px 20px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
  }
}
</style>
